var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVehiculos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "General-System",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 13,
    viewBox: "0 0 26 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00095b;\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GeneralSystems_VehicleFeatures_Car_48",
    "data-name": "GeneralSystems/VehicleFeatures/Car/48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "O006a---Vehicle-Features---Car",
    className: "cls-1",
    d: "M2.3,22.4A1.3,1.3,0,0,1,1,21.1V15.9l5.2-2.6A13.431,13.431,0,0,1,12.05,12a11.868,11.868,0,0,1,5.46,1.3c1.04.585,4.29,2.6,4.29,2.6l3.25.78A2.525,2.525,0,0,1,27,19.215V22.4H24.4a2.6,2.6,0,1,1-5.2,0H8.8a2.546,2.546,0,1,1-.325-1.3h11.05a2.641,2.641,0,0,1,4.55,0H25.7V19.215a1.253,1.253,0,0,0-.975-1.235l-3.445-.845s-3.38-2.08-4.42-2.665a9.76,9.76,0,0,0-4.81-1.17,12.646,12.646,0,0,0-5.265,1.17c-.26.13-3.12,1.56-4.485,2.21Zm3.9-1.3a1.3,1.3,0,1,0,1.3,1.3A1.3,1.3,0,0,0,6.2,21.1Zm15.6,0a1.3,1.3,0,1,0,1.3,1.3A1.3,1.3,0,0,0,21.8,21.1Z",
    transform: "translate(-1 -12)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehiculos);
export default __webpack_public_path__ + "static/media/vehiculos.c03cef40d201ebd9bb029f52fb77e0b3.svg";
export { ForwardRef as ReactComponent };